export default __webpack_public_path__ + "static/media/vya_logo_black.76665a5b.png";